// export const apibaseurl = "http://192.168.1.17:8001";
export const apibaseurl = "https://engine.auptech.in";

export const adminAuth_baseUrl = `/api/v1/admin/auth`;
export const admin_baseUrl = `/api/v1/admin`;
export const master_baseUrl = `/api/v1/master`;
export const trach_case_base_url = "/api/v1/admin/track-case-progress";

const webservice_url = {
  // auth
  login: `${adminAuth_baseUrl}/auth-login`,
  verify_otp: `${adminAuth_baseUrl}/verify-otp`,
  resend_otp: `${adminAuth_baseUrl}/resend-otp`,
  forgot_password: `${adminAuth_baseUrl}/forgot-password`,
  change_password: `${adminAuth_baseUrl}/change-password`,
  verify_forgot_otp: `${adminAuth_baseUrl}/verify-forgot-password-otp`,
  reset_password: `${adminAuth_baseUrl}/reset-password`,
  countries: `${master_baseUrl}/countries`,
  intake_method: `${master_baseUrl}/intake-methods`,
  candidate_approval: `${master_baseUrl}/candidate-approvals`,
  account_type_tiers: `${master_baseUrl}/account-type-tiers`,
  industries: `${master_baseUrl}/industries`,

  // bhawna
  getOrganizationsByUserID: `${master_baseUrl}/organizations/my`,

  getLocationByMultiProject: `${master_baseUrl}/projects/locations`,
  getProgramByMultiLocation: `${master_baseUrl}/projects/programs`,
  getDepartmentByMultiProgram: `${master_baseUrl}/programs/departments`,

  createSingleInvite: `${admin_baseUrl}/invites/single-invite`,
  uploadBulkInvite: `${admin_baseUrl}/invites/bulk-invite`,
  getValidCandidateByOrder: `${admin_baseUrl}/invites/valid-candidates`,
  getInvalidCandidateByOrder: `${admin_baseUrl}/invites/invalid-candidates`,

  assignOrderToSingleCase: `${admin_baseUrl}/invites/add-single-case`,
  assignOrderToBulk: `${admin_baseUrl}/invites/add-bulk-case`,

  getAllOrders: `${admin_baseUrl}/invites/all-orders`,
  getTotalCounts: `${trach_case_base_url}/case-status-counts`,
  getTotalCountsGlobal: `${trach_case_base_url}/report-status-counts`,
  HrPendingCounts: `${trach_case_base_url}/report-status-count`,

  getApplicationTableData: `${trach_case_base_url}/track-cases`,
  ViewLogAPI: `${trach_case_base_url}/case-activity-log`,
  sendInvitationAPI: "/api/v1/admin/invites/resend-invitation",
  getOrderHierarchy: `${master_baseUrl}/orders`,
  getCheckOrderHierarchy: `${admin_baseUrl}/invites/check-order`,
  workInProgressTableAPI: `${trach_case_base_url}/work-in-progress-report`,
  caseDetailsAPI: `${trach_case_base_url}/case-summary`,
  StopCaseTableAPI: `${trach_case_base_url}/stopped-cases-report`,
  GetCaseStatus: `${admin_baseUrl}/case-statuses`,
  GetCheckStatus: `${admin_baseUrl}/checks/status`,

  updateCaseStatus: `${admin_baseUrl}/cases/status`,
  getInsufficiencyReportAPI: `${trach_case_base_url}/insufficiency-report`,
  getExpiredInsuffReportAPI: `${trach_case_base_url}/insufficiency-expired-report`,
  dashboardMonthsReportAPI: `${trach_case_base_url}/monthly-sla-trend`,
  get_insufficiency_details: `${apibaseurl}/insufficiency/template`,
  get_insufficiency_documents: `${apibaseurl}/insufficiency/documents`,
  get_all_artifacts: `${apibaseurl}/api/v1/agency-atrifact`,
  addMoreChecksAPI: "/api/v1/admin/add-checks",
  AllCandidateList: "/api/v1/admin/candidates-without-drug-test",
  DownloadAllCandidateList: "/api/v1/admin/candidates-without-drug-test-list",
  UploadDrugCandidate: "/api/v1/admin/add-drug-report-bulk",
  AllCandidateDrugList: "/api/v1/admin/drug-test-category",
  AddCandidateReport: "/api/v1/admin/add-drug-report",
  AllDrugReports: "/api/v1/admin/drug-reports",
  DownloadAssestedReport: "/api/v1/agency-atrifact",

  // paid api's start
  BgvbulkVerification: "/api/v1/pre-bgv/bulk-verification", 
  GetBgvStatus: "/api/v1/pre-bgv/pre-bgv-status", 
  // paid api's end
};

export default webservice_url;

//  getProjectsByOrgId: `${master_baseUrl}/organizations/{{orgId}}/projects`,
//  getLocationsByProjectId: `${master_baseUrl}/projects/{{projectId}}/locations`,
//  getProgramsByProjectAndLocation: `${master_baseUrl}/projects/{{projectId}}/locations/India/programs`,
//  getDepartmentsByProgramId: `${master_baseUrl}/programs/{{programId}}/departments`,
//  getPackageByDepartmentId: `${master_baseUrl}/departments/{{departmentId}}/packages`,

//  getAllOrder: `{{inviteBaseUrl}}/all-orders`,
//  getValidCandidateByOrder: `{{inviteBaseUrl}}/valid-candidates/{{orderId}}`,
//  getInValidCandidateByOrder: `{{inviteBaseUrl}}/invalid-candidates/{{orderId}}`,
